import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@metarouter-private/mr-mui';
import CopyToClipboard from 'app/components/CopyToClipboard';
import DebuggerDrawerNavigation from 'app/event-monitoring/event-debugger/event-debugger-table/DebuggerDrawer/DebuggerDrawerNavigation';
import { base64DecodePretty } from 'app/shared/decoders/base64Decoder';
import { AceCodeEditor } from '@ion/components';

export default function DebuggerContent({
  content,
  lang,
  renderActions,
  decoder = base64DecodePretty,
  emptyMessage = 'No data for this view.',
}) {
  const value = content ? decoder({ encodedData: content, lang }) : emptyMessage;

  const allowCodeFolding = lang === 'json';

  return (
    <Stack direction="column">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <DebuggerDrawerNavigation />
        <Stack direction="row" alignItems="center">
          {renderActions && renderActions(value)}
          <CopyToClipboard text={value} />
        </Stack>
      </Stack>

      <AceCodeEditor
        foldable={allowCodeFolding}
        rows={30}
        name="debugger-drawer-content"
        readOnly
        lang={lang}
        value={value}
      />
    </Stack>
  );
}

DebuggerContent.propTypes = {
  content: PropTypes.string,
  lang: PropTypes.string.isRequired,
  renderActions: PropTypes.func,
  decoder: PropTypes.func,
  emptyMessage: PropTypes.string,
};
